import Vue from "vue";
import { User } from "kinnect-models";

export default {
	namespaced: true,

	getters: {
		isAuthenticated() {
			if ( Vue.auth ) {
				return Vue.auth.check();
			}
		},
		user() {
			if ( Vue.auth ) {
				const user = Vue.auth.user();

				if ( user && Object.keys( user ).length ) {
					return new User( user );
				}
			}
		},
		userID( store, storeGetters ) {
			if ( storeGetters.user ) {
				return storeGetters.user.id;
			}
		},
		userName( store, storeGetters ) {
			if ( storeGetters.user ) {
				return `${storeGetters.user.firstName} ${storeGetters.user.lastName}`;
			}
		}
	},

	actions: {
		login( store, userInfo ) {
			if ( store.getters.isAuthenticated ) {
				return new Promise( resolve => resolve() );
			}

			const redirectData = Vue.auth.redirect();
			let redirect = { name: "front" };
			const blacklistedRedirects = [
				"logout",
				"login"
			];

			if ( redirectData
				&& blacklistedRedirects.indexOf( redirectData.from.name ) === -1
			) {
				redirect = {
					name: redirectData.from.name,
					query: redirectData.from.query
				};
			}

			if ( store.rootState.oneSignal.idDevice ) {
				userInfo.oneSignalId = store.rootState.oneSignal.idDevice;
			}

			return Vue.auth.login( {
				redirect,
				rememberMe: true,
				data: userInfo,
				success( { data } ) {
					Vue.auth.user( data.user );
				}
			} );

		},

		logout( store, makeRequest = true ) {
			const data = {};

			if ( store.rootState.oneSignal.idDevice ) {
				data.oneSignalId = store.rootState.oneSignal.idDevice;
			}

			if ( !store.getters.isAuthenticated ) {
				makeRequest = false;
			}

			try {
				Vue.auth.logout( {
					data,
					makeRequest,
					redirect: { name: "login" }
				} );

				return store.dispatch( "app/setDrawer", false, { root: true } );
			} catch ( e ) {
				return store.dispatch( "logout", false );
			}
		}
	}
};
